import React from "react";
import "./MessageZone.css";

const MessageZone = (props) => {
  return (
    <div className="message-zone-container">
      <div className="message-zone-header">
        <div className="message-zone-header-item">
          <div className="message-zone-label">Envoye le</div>
          <div className="message-zone-value-blue">{props.le}</div>
        </div>
        {props.rec && (
          <div className="message-zone-header-item">
            <div className="message-zone-label">Envoye a</div>
            <div className="message-zone-value-blue">{props.rec}</div>
          </div>
        )}
        {props.par && (
          <div className="message-zone-header-item">
            <div className="message-zone-label">Envoye Par</div>
            <div className="message-zone-value-blue">{props.par}</div>
          </div>
        )}
      </div>
      <div className="message-zone-subject">
        <div className="message-zone-value-red">{props.objet}</div>
      </div>
      <div className="message-zone-content">
        <div className="message-zone-value-black">{props.contenu}</div>
      </div>
    </div>
  );
};

export default MessageZone;